import React, { ChangeEvent, Component } from 'react';
import { InputFieldWrapper } from '@components-shared/forms/FieldLabel';
import cn from 'classnames';
import { Attributes, FormType } from './formField.interface';

interface IProps {
  onChange: (name: string, value: string) => void;
  limit?: number;
  name: string;
  valid: boolean;
  attributes: Attributes;
  getAttributes: (form: FormType) => Attributes;
  form: FormType;
  title: string;
  validationMessage: string;
  value: string;
  hintMessage?: string;
  required?: boolean;
  className: string;
  type: string;
  testID?: string;
  tooltip?: string;
}

class TextArea extends Component<IProps> {
  onChange = ({ target }: ChangeEvent<HTMLTextAreaElement>) => {
    const { onChange, limit } = this.props;
    const { name } = target;
    let { value } = target;

    if (limit && value.length > limit) {
      value = value.slice(0, limit);
    }

    onChange(name, value);
  };

  calculateTextAreaStyle = () => {
    const { limit } = this.props;
    const defaultPadding = 8;
    const charWidth = 7;
    const inputPaddingRight = limit ? defaultPadding + limit.toString().length * charWidth : defaultPadding;

    return limit ? { paddingRight: inputPaddingRight } : {};
  };

  renderTextArea = () => {
    const { name, value, valid, attributes, getAttributes, form } = this.props;

    const attr = getAttributes ? { ...attributes, ...getAttributes(form) } : attributes;

    return (
      <textarea
        className={cn('form__input textarea', { invalid: !valid })}
        style={this.calculateTextAreaStyle()}
        name={name}
        onChange={this.onChange}
        value={value}
        {...attr}
      />
    );
  };

  renderRemainingLimit = () => {
    const { limit, value } = this.props;

    if (!limit) {
      return null;
    }

    const remainingChars = value !== null ? limit - value.length : limit;

    return <span className="form__input-limit">{remainingChars}</span>;
  };

  renderTextAreaWithLimit = () => {
    const { limit } = this.props;

    if (limit) {
      return (
        <div className="form__field-group">
          {this.renderRemainingLimit()}
          {this.renderTextArea()}
        </div>
      );
    } else {
      return this.renderTextArea();
    }
  };

  render() {
    const {
      name,
      title,
      valid,
      validationMessage,
      hintMessage,
      required,
      className,
      testID = 'formTextArea',
      tooltip,
    } = this.props;

    return (
      <InputFieldWrapper
        title={title}
        tooltip={tooltip}
        hintMessage={hintMessage}
        name={name}
        required={required}
        className={`textarea__fieldset ${className}`}
        labelClassName="textarea__field"
        valid={valid}
        validationMessage={validationMessage}
        testID={testID}>
        {this.renderTextAreaWithLimit()}
      </InputFieldWrapper>
    );
  }
}

export default TextArea;
